{
  "Clear search": "Очистить поиск"
}
